// Styles
import './Maintenance.scss';

import cn from 'classnames';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import ExternalLink from '@/common/components/atoms/ExternalLink/ExternalLink';
import { useConfig } from '@/common/contexts/ConfigContext';
import useTheme from '@/common/hooks/useTheme';
import { ReactComponent as Image } from '@/ebat/assets/images/maintenance.svg';
import { ReactComponent as ImageLm } from '@/ebat/assets/images/maintenance-lm.svg';
import { ReactComponent as LogoEA } from '@/ebat/assets/logos/espace-aubade.svg';
import { ReactComponent as LogoLME } from '@/ebat/assets/logos/le-materiel-electrique.svg';
import { ReactComponent as LogoLM } from '@/ebat/assets/logos/les-materiaux.svg';

const Maintenance = () => {
  const { t } = useTranslation();
  const { Logo } = useTheme();
  const { env, isEbat, isChrono, isMateriaux } = useConfig();

  const formatEnv = () => {
    switch (env) {
      case 'ebat':
        return 'eBat';
      case 'materiaux':
        return 'Les Matériaux Express';
      case 'chrono':
        return 'Chrono';

      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>
          {`${t('common:entities:maintenance.title')} - ${t(
            `${env}:messages:title`,
          )}`}
        </title>
      </Helmet>
      <main
        className={cn('main page__maintenance', {
          'page__maintenance--ebat': isEbat,
          'page__maintenance--chrono': isChrono,
          'page__maintenance--materiaux': isMateriaux,
        })}
        data-qa-id="page-maintenance"
      >
        <div className="maintenance">
          <div className="maintenance__header">
            <Logo className="maintenance__logo" />
          </div>
          <div className="maintenance__content">
            <span className={cn('maintenance__title')}>
              {t('common:entities:maintenance.title')}
            </span>
            <span className="maintenance__description">
              {' '}
              {t('common:entities:maintenance.text', { env: formatEnv() })}
            </span>
          </div>
          <div className="maintenance__footer">
            <ul className="list-none">
              {!isMateriaux && (
                <li className="list-none__item">
                  <ExternalLink
                    className="list-none__link"
                    href="https://www.espace-aubade.fr"
                  >
                    <LogoEA className="logo" />
                  </ExternalLink>
                </li>
              )}

              <li className="list-none__item">
                <ExternalLink
                  className="list-none__link"
                  href="https://www.lesmateriaux.fr"
                >
                  <LogoLME className="logo" />
                </ExternalLink>
              </li>
              <li className="list-none__item">
                <ExternalLink
                  className="list-none__link"
                  href="https://www.lesmateriaux.fr"
                >
                  <LogoLM className="logo" />
                </ExternalLink>
              </li>
            </ul>
          </div>
        </div>
        {isMateriaux ? (
          <ImageLm className="image" />
        ) : (
          <Image className="image" />
        )}
      </main>
    </>
  );
};

export default Maintenance;
